import { render, staticRenderFns } from "./lkuDim.vue?vue&type=template&id=5bbc5a6e"
import script from "./lkuDim.vue?vue&type=script&lang=js"
export * from "./lkuDim.vue?vue&type=script&lang=js"
import style0 from "./lkuDim.vue?vue&type=style&index=0&id=5bbc5a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports